module.exports = __webpack_public_path__ + "static/img/leftImg.7f3f8ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageTwo/leftImg.png
// module id = vIJA
// module chunks = 0